module.exports = __webpack_public_path__ + "static/img/zhengcexinxi_icon_pre.55afb1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav/zhengcexinxi_icon_pre.png
// module id = sWKc
// module chunks = 22